import { render, staticRenderFns } from "./CargoQuoteQuery.vue?vue&type=template&id=16ab5499&"
import script from "./CargoQuoteQuery.vue?vue&type=script&lang=js&"
export * from "./CargoQuoteQuery.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuoteQuery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuoteQuery.vue"
export default component.exports